import React from "react";
import { Table } from "reactstrap";
import "./invite-respondants-modal.css";
import Relationshiptype from "../../../Utils/RelationshipType";

const Renderpopoverinner = (props) => {
  return (
    <div className="inner-content-wrapper">
      <h1>Note : Report will be available based on the minimum respondents</h1>
      <Table>
        <thead>
          <tr>
            <th className="tableHeaders">Relationship Name</th>
            <th className="tableHeaders">Min Respondents</th>
            <th className="tableHeaders">Report Style</th>
          </tr>
        </thead>
        <tbody>{Relationshiptype(props.relationShipName)}</tbody>
      </Table>
      <button onClick={props.handleClosePopOver}>Got It</button>
    </div>
  );
};

export default Renderpopoverinner;



// WEBPACK FOOTER //
// ./src/new/Components/CompletedAssessment/Invite-Respondants-Modal/Popover-inner.jsx